(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[313],{

/***/ 70277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ ForwardRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


var SvgChevronRight = function SvgChevronRight(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289Z"
  })));
};
var ForwardRef = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(SvgChevronRight);

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjI5Mjg5IDUuMjkyODlDOC42ODM0MiA0LjkwMjM3IDkuMzE2NTggNC45MDIzNyA5LjcwNzExIDUuMjkyODlMMTUuNzA3MSAxMS4yOTI5QzE2LjA5NzYgMTEuNjgzNCAxNi4wOTc2IDEyLjMxNjYgMTUuNzA3MSAxMi43MDcxTDkuNzA3MTEgMTguNzA3MUM5LjMxNjU4IDE5LjA5NzYgOC42ODM0MiAxOS4wOTc2IDguMjkyODkgMTguNzA3MUM3LjkwMjM3IDE4LjMxNjYgNy45MDIzNyAxNy42ODM0IDguMjkyODkgMTcuMjkyOUwxMy41ODU4IDEyTDguMjkyODkgNi43MDcxMUM3LjkwMjM3IDYuMzE2NTggNy45MDIzNyA1LjY4MzQyIDguMjkyODkgNS4yOTI4OVoiIC8+Cjwvc3ZnPgo=");

/***/ }),

/***/ 19752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ ForwardRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


var SvgGraphicLines2 = function SvgGraphicLines2(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 647,
    height: 674,
    viewBox: "0 0 647 674",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M633.133 -34.9798L471.773 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M574.4 -34.9798L413.04 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M515.666 -34.9798L354.293 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M456.92 -34.9798L295.56 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M398.186 -34.9798L236.826 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M339.453 -34.9798L178.093 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M280.707 -34.9798L119.347 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M221.973 -34.9798L60.6133 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M163.24 -34.9798L1.87988 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M588.36 227.097H562L620.32 -35.7656H646.68L588.36 227.097Z"
  })), _path11 || (_path11 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M529.614 227.097H503.254L561.587 -35.7656H587.947L529.614 227.097Z"
  })), _path12 || (_path12 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M470.88 227.097H444.521L502.84 -35.7656H529.2L470.88 227.097Z"
  })), _path13 || (_path13 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M412.147 227.097H385.787L444.107 -35.7656H470.467L412.147 227.097Z"
  })), _path14 || (_path14 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M353.4 227.097H327.04L385.373 -35.7656H411.733L353.4 227.097Z"
  })), _path15 || (_path15 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M294.667 227.097H268.307L326.64 -35.7656H353L294.667 227.097Z"
  })), _path16 || (_path16 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M235.934 227.097H209.574L267.894 -35.7656H294.254L235.934 227.097Z"
  })), _path17 || (_path17 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M177.201 227.097H150.841L209.161 -35.7656H235.521L177.201 227.097Z"
  })), _path18 || (_path18 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M118.454 227.097H92.0938L150.427 -35.7656H176.787L118.454 227.097Z"
  })));
};
var ForwardRef = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(SvgGraphicLines2);

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ("data:image/svg+xml;base64,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");

/***/ }),

/***/ 18298:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/press",
      function () {
        return __webpack_require__(55949);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 55949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ press; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/hooks/use-update-header.tsx
var use_update_header = __webpack_require__(41898);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/utils/constants.ts + 14 modules
var constants = __webpack_require__(68579);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/hooks/use-clean-header.tsx
var use_clean_header = __webpack_require__(90573);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/seo/index.tsx
var seo = __webpack_require__(25352);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../libs/ui-kit/src/lib/components/button/button.tsx
var button_button = __webpack_require__(79544);
;// CONCATENATED MODULE: ../../libs/ui-kit/src/lib/assets/icons/download.svg
var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


var SvgDownload = function SvgDownload(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4V13.5858L7.70711 10.2929C7.31658 9.90237 6.68342 9.90237 6.29289 10.2929C5.90237 10.6834 5.90237 11.3166 6.29289 11.7071L11.2922 16.7064C11.2946 16.7088 11.297 16.7112 11.2995 16.7136C11.3938 16.8063 11.502 16.8764 11.6172 16.9241C11.7343 16.9727 11.8625 16.9996 11.997 17C11.998 17 11.999 17 12 17C12.001 17 12.002 17 12.003 17C12.2746 16.9992 12.5208 16.8901 12.7005 16.7136C12.703 16.7112 12.7054 16.7088 12.7078 16.7064L17.7071 11.7071C18.0976 11.3166 18.0976 10.6834 17.7071 10.2929C17.3166 9.90237 16.6834 9.90237 16.2929 10.2929L13 13.5858V4ZM4 16C4.55228 16 5 16.4477 5 17V19C5 19.2652 5.10536 19.5196 5.29289 19.7071C5.48043 19.8946 5.73478 20 6 20H18C18.2652 20 18.5196 19.8946 18.7071 19.7071C18.8946 19.5196 19 19.2652 19 19V17C19 16.4477 19.4477 16 20 16C20.5523 16 21 16.4477 21 17V19C21 19.7957 20.6839 20.5587 20.1213 21.1213C19.5587 21.6839 18.7957 22 18 22H6C5.20435 22 4.44129 21.6839 3.87868 21.1213C3.31607 20.5587 3 19.7957 3 19V17C3 16.4477 3.44772 16 4 16Z"
  })));
};
var ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgDownload);

/* harmony default export */ var download = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMyA0QzEzIDMuNDQ3NzIgMTIuNTUyMyAzIDEyIDNDMTEuNDQ3NyAzIDExIDMuNDQ3NzIgMTEgNFYxMy41ODU4TDcuNzA3MTEgMTAuMjkyOUM3LjMxNjU4IDkuOTAyMzcgNi42ODM0MiA5LjkwMjM3IDYuMjkyODkgMTAuMjkyOUM1LjkwMjM3IDEwLjY4MzQgNS45MDIzNyAxMS4zMTY2IDYuMjkyODkgMTEuNzA3MUwxMS4yOTIyIDE2LjcwNjRDMTEuMjk0NiAxNi43MDg4IDExLjI5NyAxNi43MTEyIDExLjI5OTUgMTYuNzEzNkMxMS4zOTM4IDE2LjgwNjMgMTEuNTAyIDE2Ljg3NjQgMTEuNjE3MiAxNi45MjQxQzExLjczNDMgMTYuOTcyNyAxMS44NjI1IDE2Ljk5OTYgMTEuOTk3IDE3QzExLjk5OCAxNyAxMS45OTkgMTcgMTIgMTdDMTIuMDAxIDE3IDEyLjAwMiAxNyAxMi4wMDMgMTdDMTIuMjc0NiAxNi45OTkyIDEyLjUyMDggMTYuODkwMSAxMi43MDA1IDE2LjcxMzZDMTIuNzAzIDE2LjcxMTIgMTIuNzA1NCAxNi43MDg4IDEyLjcwNzggMTYuNzA2NEwxNy43MDcxIDExLjcwNzFDMTguMDk3NiAxMS4zMTY2IDE4LjA5NzYgMTAuNjgzNCAxNy43MDcxIDEwLjI5MjlDMTcuMzE2NiA5LjkwMjM3IDE2LjY4MzQgOS45MDIzNyAxNi4yOTI5IDEwLjI5MjlMMTMgMTMuNTg1OFY0Wk00IDE2QzQuNTUyMjggMTYgNSAxNi40NDc3IDUgMTdWMTlDNSAxOS4yNjUyIDUuMTA1MzYgMTkuNTE5NiA1LjI5Mjg5IDE5LjcwNzFDNS40ODA0MyAxOS44OTQ2IDUuNzM0NzggMjAgNiAyMEgxOEMxOC4yNjUyIDIwIDE4LjUxOTYgMTkuODk0NiAxOC43MDcxIDE5LjcwNzFDMTguODk0NiAxOS41MTk2IDE5IDE5LjI2NTIgMTkgMTlWMTdDMTkgMTYuNDQ3NyAxOS40NDc3IDE2IDIwIDE2QzIwLjU1MjMgMTYgMjEgMTYuNDQ3NyAyMSAxN1YxOUMyMSAxOS43OTU3IDIwLjY4MzkgMjAuNTU4NyAyMC4xMjEzIDIxLjEyMTNDMTkuNTU4NyAyMS42ODM5IDE4Ljc5NTcgMjIgMTggMjJINkM1LjIwNDM1IDIyIDQuNDQxMjkgMjEuNjgzOSAzLjg3ODY4IDIxLjEyMTNDMy4zMTYwNyAyMC41NTg3IDMgMTkuNzk1NyAzIDE5VjE3QzMgMTYuNDQ3NyAzLjQ0NzcyIDE2IDQgMTZaIi8+Cjwvc3ZnPgo=");
// EXTERNAL MODULE: ../../libs/website-components/src/lib/assets/icons/graphic-lines-2.svg
var graphic_lines_2 = __webpack_require__(19752);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/press/guidelines-card/index.module.scss
var index_module = __webpack_require__(81564);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/components/press/guidelines-card/index.tsx






const PressGuidelinesCard = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((index_module_default())["card-wrapper"], className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (index_module_default())["content-wrapper"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (index_module_default()).title,
                        children: "Media Kit and Brand Guidelines"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.zx, {
                        size: "large",
                        variant: "on-brand",
                        startAdornment: ForwardRef,
                        className: (index_module_default()).button,
                        href: "https://platform-statics.olby.com/media-kit.zip",
                        isExternal: true,
                        children: "Download Media Kit"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.zx, {
                        size: "large",
                        variant: "on-brand",
                        startAdornment: ForwardRef,
                        className: (index_module_default())["brand-guidelines"],
                        href: "https://platform-statics.olby.com/brandbook-olby-out-2022.pdf",
                        isExternal: true,
                        target: "_blank",
                        children: "Download Brand Guidelines"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(graphic_lines_2/* ReactComponent */.r, {
                className: (index_module_default())["graphic-lines"]
            })
        ]
    });
};

// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/contact-us/card/index.tsx
var card = __webpack_require__(25175);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/from-our-blog-section/index.tsx
var from_our_blog_section = __webpack_require__(50096);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/layouts/website-layout/index.tsx + 9 modules
var website_layout = __webpack_require__(46087);
// EXTERNAL MODULE: ../../libs/ui-kit/src/lib/components/link/link.tsx
var link_link = __webpack_require__(946);
// EXTERNAL MODULE: ../../libs/data-access/src/lib/graphql/website/blog-post-fragments.generated.ts
var blog_post_fragments_generated = __webpack_require__(71285);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/umd/index.production.js
var index_production = __webpack_require__(60431);
// EXTERNAL MODULE: ../../libs/data-access/src/lib/custom-fetcher/index.ts
var custom_fetcher = __webpack_require__(97885);
;// CONCATENATED MODULE: ../../libs/data-access/src/lib/graphql/website/get-website-press-page.generated.ts
/* eslint-disable */ // @ts-nocheck



const GetWebsitePressPageDocument = /*#__PURE__*/ "\n    query GetWebsitePressPage($input: WebsitePressPageQueryArgs!) {\n  getWebsitePressPage(input: $input) {\n    data {\n      id\n      posts {\n        post {\n          article\n          resume\n          slug\n          title\n          readingTime\n          ...GetBlogPostBySlugAuthorFragment\n          ...GetBlogPostBySlugImageFragment\n          ...GetBlogPostBySlugTagsFragment\n          ...GetBlogPostBySlugSeoFragment\n          ...GetBlogPostBySlugCategoryFragment\n        }\n      }\n    }\n  }\n}\n    ".concat(blog_post_fragments_generated/* GetBlogPostBySlugAuthorFragmentFragmentDoc */.s_, "\n").concat(blog_post_fragments_generated/* GetBlogPostBySlugImageFragmentFragmentDoc */.FD, "\n").concat(blog_post_fragments_generated/* GetBlogPostBySlugTagsFragmentFragmentDoc */.E6, "\n").concat(blog_post_fragments_generated/* GetBlogPostBySlugSeoFragmentFragmentDoc */.mW, "\n").concat(blog_post_fragments_generated/* GetBlogPostBySlugCategoryFragmentFragmentDoc */.Wj);
const useGetWebsitePressPageQuery = (variables, options)=>(0,index_production.useQuery)([
        "GetWebsitePressPage",
        variables
    ], (0,custom_fetcher/* customFetcher */.k)(GetWebsitePressPageDocument, variables), options);
useGetWebsitePressPageQuery.getKey = (variables)=>[
        "GetWebsitePressPage",
        variables
    ];
const useInfiniteGetWebsitePressPageQuery = (variables, options)=>{
    var _pageParam;
    return (0,index_production.useInfiniteQuery)([
        "GetWebsitePressPage.infinite",
        variables
    ], (metaData)=>(0,custom_fetcher/* customFetcher */.k)(GetWebsitePressPageDocument, {
            ...variables,
            ...(_pageParam = metaData.pageParam) !== null && _pageParam !== void 0 ? _pageParam : {}
        })(), options);
};
useInfiniteGetWebsitePressPageQuery.getKey = (variables)=>[
        "GetWebsitePressPage.infinite",
        variables
    ];
useGetWebsitePressPageQuery.fetcher = (variables, options)=>(0,custom_fetcher/* customFetcher */.k)(GetWebsitePressPageDocument, variables, options);

// EXTERNAL MODULE: ../../libs/data-access/src/lib/types.generated.ts
var types_generated = __webpack_require__(9432);
// EXTERNAL MODULE: ../../libs/utils/src/lib/website/website-strapi.ts
var website_strapi = __webpack_require__(82185);
// EXTERNAL MODULE: ./pages/press/index.module.scss
var press_index_module = __webpack_require__(56838);
var press_index_module_default = /*#__PURE__*/__webpack_require__.n(press_index_module);
;// CONCATENATED MODULE: ./pages/press/index.tsx







const SEO = {
    title: "Press // Olby"
};
const Press = ()=>{
    const sectionRef = (0,react.useRef)(null);
    (0,use_update_header/* useUpdateHeader */.G)(sectionRef, constants/* HEADER_THEMES.NEUTRAL_BACKGROUND */._.NEUTRAL_BACKGROUND);
    (0,use_clean_header/* useCleanHeader */._)();
    const { data  } = useGetWebsitePressPageQuery({
        input: {
            locale: types_generated/* Locale.En */.go.En
        }
    });
    const posts = (0,react.useMemo)(()=>{
        var ref, ref1;
        if (!(data === null || data === void 0 ? void 0 : (ref = data.getWebsitePressPage) === null || ref === void 0 ? void 0 : ref.data)) {
            return [];
        }
        const list = (ref1 = data.getWebsitePressPage.data.posts) === null || ref1 === void 0 ? void 0 : ref1.map((param)=>{
            let { post  } = param;
            return post;
        });
        const formattedArticles = (0,website_strapi/* websiteFormatArticleList */.o)(list || []);
        return formattedArticles;
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* WebsiteSeo */.P, {
                seo: SEO
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (press_index_module_default())["content-wrapper"],
                ref: sectionRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: (press_index_module_default()).title,
                        children: "Press"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (press_index_module_default()).description,
                        children: [
                            "Don't see what you're looking for?",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.rU, {
                                href: "/contact-us",
                                prefetch: false,
                                children: "Contact us"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (press_index_module_default()).content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PressGuidelinesCard, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* GeneralInformationCard */.e, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(from_our_blog_section/* FromOurBlogSection */.f, {
                posts: posts
            })
        ]
    });
};
/* harmony default export */ var press = (Press);
Press.getLayout = (page)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(website_layout/* WebsiteLayout */.CG, {
        shouldChangeBgColor: true,
        headerInitialTheme: constants/* HEADER_THEMES.NEUTRAL_BACKGROUND */._.NEUTRAL_BACKGROUND,
        children: page
    });
};


/***/ }),

/***/ 97885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ customFetcher; }
/* harmony export */ });
const customFetcher = (query, variables, options)=>{
    return async ()=>{
        const NEXT_PUBLIC_API_URL = "https://platform-api.olby.com/graphql";
        const res = await fetch(NEXT_PUBLIC_API_URL || "https://platform-api.olby.com/graphql", {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                Accept: "application/json",
                ...options
            },
            body: JSON.stringify({
                query,
                variables
            })
        });
        const json = await res.json();
        if (json.errors) {
            const errors = json.errors[0];
            throw errors;
        }
        return json.data;
    };
};


/***/ }),

/***/ 25175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ GeneralInformationCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _platform_ui_kit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(946);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70277);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36257);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_2__);





const GeneralInformationCard = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().card), className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().title),
                children: "Looking for general information?"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().description),
                children: "We have FAQs to help you."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_platform_ui_kit__WEBPACK_IMPORTED_MODULE_3__/* .Link */ .rU, {
                href: "/faq/talent",
                endIcon: _icons__WEBPACK_IMPORTED_MODULE_4__/* .ReactComponent */ .r,
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["talent-link"]),
                prefetch: false,
                children: "Talent FAQ"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_platform_ui_kit__WEBPACK_IMPORTED_MODULE_3__/* .Link */ .rU, {
                href: "/faq/companies",
                endIcon: _icons__WEBPACK_IMPORTED_MODULE_4__/* .ReactComponent */ .r,
                prefetch: false,
                children: "Companies FAQ"
            })
        ]
    });
};


/***/ }),

/***/ 50096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ FromOurBlogSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _platform_ui_kit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79544);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _blog_article_list__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34792);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12601);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2__);





const FromOurBlogSection = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((param, ref)=>{
    let { posts  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["article-section"]),
        ref: ref,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().title),
                children: "From our blog"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_platform_ui_kit__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().button),
                href: "/blog",
                size: "large",
                prefetch: false,
                children: "Find more articles"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_blog_article_list__WEBPACK_IMPORTED_MODULE_4__/* .ArticleList */ .w, {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["article-list"]),
                posts: posts,
                hideThirdCard: true
            })
        ]
    });
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (FromOurBlogSection)));


/***/ }),

/***/ 56838:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content-wrapper":"press_content-wrapper__l38CS","title":"press_title__05M3Y","theme--light":"press_theme--light__ZL_QX","theme--dark":"press_theme--dark__3gfSa","description":"press_description__Eixst","content":"press_content___rbPH","fade-in-up":"press_fade-in-up__iO3yP","fade-in-opacity":"press_fade-in-opacity__domXO","fade-in-up-opacity":"press_fade-in-up-opacity__cWBPw","fade-out-opacity":"press_fade-out-opacity__Eee7M","fade-out-left":"press_fade-out-left__hY26v"};

/***/ }),

/***/ 36257:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__g1LzQ","theme--light":"card_theme--light__AkvC6","theme--dark":"card_theme--dark__fFTuN","title":"card_title__UBQcT","description":"card_description__VBl68","talent-link":"card_talent-link__ikacG","fade-in-up":"card_fade-in-up__z7JnV","fade-in-opacity":"card_fade-in-opacity__gc7oY","fade-in-up-opacity":"card_fade-in-up-opacity__2RsMx","fade-out-opacity":"card_fade-out-opacity__UkOqK","fade-out-left":"card_fade-out-left__OByoV"};

/***/ }),

/***/ 12601:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"article-section":"styles_article-section__suz_J","title":"styles_title__KMHMh","button":"styles_button__Ze3uu","article-list":"styles_article-list__ZdsOV","fade-in-up":"styles_fade-in-up___5bZo","fade-in-opacity":"styles_fade-in-opacity__YCvaL","fade-in-up-opacity":"styles_fade-in-up-opacity__AmfuJ","fade-out-opacity":"styles_fade-out-opacity__sAnwg","fade-out-left":"styles_fade-out-left____nNW"};

/***/ }),

/***/ 81564:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card-wrapper":"guidelines-card_card-wrapper___6Lf5","theme--light":"guidelines-card_theme--light__7_6qY","theme--dark":"guidelines-card_theme--dark___hVT_","content-wrapper":"guidelines-card_content-wrapper__L_znG","title":"guidelines-card_title__DV4c4","button":"guidelines-card_button__vOV6u","brand-guidelines":"guidelines-card_brand-guidelines__xGLBp","graphic-lines":"guidelines-card_graphic-lines___EGlr","fade-in-up":"guidelines-card_fade-in-up__g5tY7","fade-in-opacity":"guidelines-card_fade-in-opacity__Pv2mu","fade-in-up-opacity":"guidelines-card_fade-in-up-opacity__JA4Lw","fade-out-opacity":"guidelines-card_fade-out-opacity__P_81f","fade-out-left":"guidelines-card_fade-out-left__f9_wf"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [350,82,577,196,559,735,857,774,888,179], function() { return __webpack_exec__(18298); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);